// REQUIRED IMPORTS
const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";

const targetSelector = "#org-details-page";

run(targetSelector, (mainEl)=>{
    const deactivateOrgURL =  mainEl.data("deactivate-org-url");
    const orgId = mainEl.data("org-id");
    const deactivateFacilityURL= mainEl.data("deactivate-facility-url");
    const pageRefreshUrl=mainEl.data("page-refresh-url");

    const activateOrg = mainEl.data("activate-org-msg");
    const deactivateOrg = mainEl.data("deactivate-org-msg") ;
    let activateDiv = render('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
            activateMsg: mainEl.data("activate-org-text")
        }
    );

    let deactivateDiv = render('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
        deactivateMsg: mainEl.data("deactivate-org-text")
        }
    );

    $('.deactivate-organization-btn').on("click", function(e) {  
        e.preventDefault();  
        let deactivateOrgModal = new SubmitModalFlow({
            confirmModalTitle: deactivateOrg,
            confirmModalBody: deactivateDiv,
            confirmModalBtnText: deactivateOrg,
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function() {
               
                    deactivateOrgModal.showLoadingModal();
                    deactivateOrg({url: deactivateOrgURL, success: deactivateSuccess, error: deactivateFailure});
                    function deactivateOrg({url, success, error}){
                        $.ajax({
                            data: orgId,
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function deactivateSuccess(){
                        deactivateOrgModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                         }, 3000);
                    }
                    function deactivateFailure(){
                        deactivateOrgModal.showFailureModal();
                    }
                }
          });
          deactivateOrgModal.init();
          deactivateOrgModal.showConfirmModal();
    });
    $('.activate-organization-btn').on("click", function(e) { 
           e.preventDefault();  
           let activateOrgModal = new SubmitModalFlow({
               confirmModalTitle: activateOrg,
               confirmModalBody: activateDiv,
               confirmModalBtnText: activateOrg,
               modalDialogClass: "q-modal-dialog-500",
               onConfirmClick: function() {
                  
                       activateOrgModal.showLoadingModal();
                       activateOrg({url: deactivateOrgURL, success: activateSuccess, error: activateFailure});
                       function activateOrg({url, success, error}){
                           $.ajax({
                               data: orgId,
                               url: url,
                               dataType:"JSON",
                               type: 'POST',
                               success: success,
                               error: error
                           });
                       }
                       function activateSuccess(){
                           activateOrgModal.showSuccessModal();
                           setTimeout(function() {
                               location.href=pageRefreshUrl;
                            }, 3000);
                       }
                       function activateFailure(){
                        activateOrgModal.showFailureModal();   
                       }
                   }
             });
             activateOrgModal.init();
             activateOrgModal.showConfirmModal();
       });
    $('.deactivate-facility-btn').on("click", function(e) { 
        e.preventDefault();  
        //const facId=$(".facilityAction").attr("id");
        const facId = $(this).data("fac-id");
           let deactivateFacilityModal = new SubmitModalFlow({
               confirmModalTitle: 'Deactivate Facility',
               confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
               confirmModalBtnText: 'Deactivate Facility',
               modalDialogClass: "q-modal-dialog-500",
               onConfirmClick: function() {
                  
                    deactivateFacilityModal.showLoadingModal();
                       deactivateFacility({url: deactivateFacilityURL, success: deactivateSuccess, error: deactivateFailure});
                       function deactivateFacility({url, success, error}){
                           $.ajax({
                               data: {
                                   facId:facId,
                               },
                               url: url,
                               dataType:"JSON",
                               type: 'POST',
                               success: success,
                               error: error
                           });
                       }
                       function deactivateSuccess(){
                        deactivateFacilityModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                            }, 3000);
                       }
                       function deactivateFailure(){
                        deactivateFacilityModal.showFailureModal();
                       }
                   }
             });
             deactivateFacilityModal.init();
             deactivateFacilityModal.showConfirmModal();
    });
    $('.activate-facility-btn').on("click", function(e) { 
           e.preventDefault();  
           const facId = $(this).data("fac-id");
           let activateFacilityModal = new SubmitModalFlow({
               confirmModalTitle: 'Activate Facility',
               confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
               confirmModalBtnText: 'Activate Facility',
               modalDialogClass: "q-modal-dialog-500",
               onConfirmClick: function() {
                activateFacilityModal.showLoadingModal();
                       activateFacility({url: deactivateFacilityURL, success: activateSuccess, error: activateFailure});
                       function activateFacility({url, success, error}) {
                           $.ajax({
                                data: {
                                facId:facId,
                                },
                                url: url,
                                dataType:"JSON",
                                type: 'POST',
                                success: success,
                                error: error
                           });
                       }
                       function activateSuccess(){
                           activateFacilityModal.showSuccessModal();
                           setTimeout(function() {
                            location.href=pageRefreshUrl;
                            }, 3000);
                       }
                       function activateFailure(){
                        activateFacilityModal.showFailureModal();
                       }
                   }
             });
             activateFacilityModal.init();
             activateFacilityModal.showConfirmModal();
    });

});


// WEBPACK FOOTER //
// ./src/pages/addressBook/details.js